const data = [
  { id: 1,
    content: 'Rúrí múcií rúrí múgúnda.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 2,
    content: 'Rúríra rútiíthambagwo rúúí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 3,
    content: 'Rúrigi rúrí nja rútiagaga gakuoha.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 4,
    content: 'Rúrigi rwetagíríria múkwa.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 5,
    content: 'Rútemaga mwenji.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 6,
    content: 'Rútuku rwa gwítiníria rútirí gíthong"ori.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 7,
    content: 'Ngúgútú ya gwíthuríra ndírí gacere',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 8,
    content: 'Nguku ya maguta ní íikagírio.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 9,
    content: 'Íreragíra rúkú-iní ní kaya kúigana.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 10,
    content: 'Ngúri ndígayagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 11,
    content: 'Ngumo ndíigana mwene.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 12,
    content: 'Nguo njega ndíikagio rútamí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 13,
    content: 'Ngwa mbere ti noru ta ngwa thutha.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 14,
    content: 'Ngwací itigathagírwo ríenjero.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 15,
    content: 'Njamba ígúaga na íngí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 16,
    content: 'Njamba ndíríagwo ní wíra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 17,
    content: 'Njamba ndírurumaga imera igírí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 18,
    content: 'Njamba ní íthaga ría rika.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 19,
    content: 'Njamba ti ikere.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 20,
    content: 'Njaú írí ndoge ona nyina ní ndoge.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 21,
    content: 'Njíka na njíka ndírí marúrú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 22,
    content: 'Njíra ndíraga múgendi hurúka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 23,
    content: 'Njíra nguhí no ya úrírí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 24,
    content: 'Njogu ndíremagwo ní múguongo wayo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 25,
    content: 'Njohi ní gacuhúra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 26,
    content: 'Ngúri ndígayagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 27,
    content: 'Njoya na múthece ndíoyagíra íngí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 28,
    content: 'Njúki ndírí mboora igírí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 29,
    content: 'Njúgúma ya njamba íthukagírio úgeni-iní.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 30,
    content: 'Njúgúma njega yumaga íkúríro na ikúrííro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 31,
    content: 'Njúka narua íthiaga onarua.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 32,
    content: 'Njukú irúgíte rúúí rúiyoru.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 33,
    content: 'Nyanja ímwe ndítíragia itega.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 34,
    content: 'Nyeki yanja ndíríkaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 35,
    content: 'Nyitíra na nginyíríra ti ímwe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 36,
    content: 'Nyoko ndítugaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 37,
    content: 'Nyoni yakaga nyúmba na múthece úmwe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 38,
    content: 'Nyoni kírimú yakaga nyúmba igúrú ría irigú íkúrú ítoí nírígútemwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 40,
    content: 'Nyota wa gíkuu ndúnyotokagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 41,
    content: 'Nyúmba íkíhía mwene ní otaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 42,
    content: 'Nyúmba Írindagíra magothe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 43,
    content: 'Nyúmba na rika itiumagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 44,
    content: 'Rúúi rútúaraga múthambíri.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 45,
    content: 'Rúrú ní rúrigi rwa kúruta rúngí kínya.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 46,
    content: 'Ruuo rúríaga mwene.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 47,
    content: 'Rutaníria múigua na mahira.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 48,
    content: 'Rwambo rúmwe rútiambaga ndarwa.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 49,
    content: 'Rwendo ní unyamarania.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 50,
    content: 'Rwendo rúkíríte thaki.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 51,
    content: 'Wendo warutire mwana wa nderi igúrú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 52,
    content: 'Tha cia arúme itirí iria.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 53,
    content: 'Thakame ní nditú kúrí maaí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 54,
    content: 'Thegere igírí itíremagwo ní mwatú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 55,
    content: 'Thína ndúrí míri.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 56,
    content: 'Thiriti ní íteanaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 57,
    content: 'Thiriti ní ya andú erí, ya atatú ní rúmena.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 58,
    content: 'Thogora ní múrurumo útarúo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 59,
    content: 'Thogora ndúrí nyina na mwana.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 60,
    content: 'Thoni itirí gathuthuma.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 61,
    content: 'Thoni Nene ní úkarí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 62,
    content: 'Thiaka úinií ndwagaga gúita míguí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 63,
    content: 'Thiarí ndíreraga kwa ngía.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 64,
    content: 'Thirí útaríhúo no worogi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 65,
    content: 'Tiga thúna: toboka ; ndúcúnaga kíihuri.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 66,
    content: 'Tiga kwonia ngarí kúhaica mútí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 67,
    content: 'Tútú urí mwana ndúnyitagia ngotho.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 68,
    content: 'Túti ngúhe hiti kerí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 69,
    content: 'Turuma yakíra kírugo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 70,
    content: 'Tuongo túingí túthúranaga túkíría.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 71,
    content: 'Úhooro ti múciire no gútemwo',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 72,
    content: 'Úbataire ahúrithagia kíhíí ime.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 73,
    content: 'Úbataire ndaconongaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 74,
    content: 'Úbataire níwe úhúraga úrírí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 75,
    content: 'Úhii ní umagwo, no úka ndumagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 76,
    content: 'Úcokereru ní úkígu.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 77,
    content: 'Úcamba ndúringaga huro ígírí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 78,
    content: 'Úcukagwo útagúteo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 79,
    content: 'Úgathena na ritho gwakía..',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 80,
    content: 'Úgethaga kíría wahanda.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 81,
    content: 'Úgí múnene útahagia ithanwa.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 82,
    content: 'Úgí ndútongoragia ta úrimú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 83,
    content: 'Úhere ní úgwatanagio.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 84,
    content: 'Úgíthondekera múcií ndúngiuga ní úríkora úngí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 85,
    content: 'Úgí ní kíhooto.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 86,
    content: 'Úgí wí mbere gúkíra hinya.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 87,
    content: 'Úgí wa múndú úmwe ndúrímaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 88,
    content: 'Úgí wa arúme útemaga ta kahiú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 90,
    content: 'Úthamaki Umaga kwa ngai.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 91,
    content: 'Útonga ní wa ngai.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 92,
    content: 'Úkabi ní múhúúnú mútu.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 93,
    content: 'Úkanyuíríore ní oí karí rita.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 94,
    content: 'Úgeni ndútúragwo',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 95,
    content: 'Úkúndihia úgacoka kúnjúria ndarío ní kíí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 96,
    content: 'Úkúrú ndugaga mbu.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 97,
    content: 'Úkúrú to wonje.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 98,
    content: 'Úkúrú úríaga wíthí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 99,
    content: 'Úmenyagwo ní múraari ti múroki.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 100,
    content: 'Úngícema múno kahahuka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 101,
    content: 'Úngíigua kaana gakiuga úndú menya kaiguíte na ithe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 102,
    content: 'Úngíona ikiríte imeretie ingí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 103,
    content: 'Útarí ndetagwo ndundu.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 104,
    content: 'Úracama arí njama.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 105,
    content: 'Írí kúhítia na mbugi ndírathaga na njoya.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 106,
    content: 'Urí kwírúkíra ndúkíthondekeka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 107,
    content: 'Úrí mwega no úkamenyeka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 108,
    content: 'Úrí witú útandiga na ndúnjeterera.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 109,
    content: 'Úrí witú útandiga na ndúnjeterera.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 110,
    content: 'Úrí wona rúkure?',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 111,
    content: 'Úrími ndúhinyaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 112,
    content: 'Úrirú ndúthiraga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 113,
    content: 'Úrugíte na úrugíte matihoyanaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 114,
    content: 'Úrutagwo mwíruti.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 115,
    content: 'Útarí maitho ndatumaga kínya.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 116,
    content: 'Útamerithítie ndatigaga kúhanda.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 117,
    content: 'Útana úninagíra múrokerwo ng"ombe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 118,
    content: 'Útana wa ngía úragíra ngoro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 119,
    content: 'Útarí kondo arí kagara.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 120,
    content: 'Útarí ndarí ngoro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 121,
    content: 'Útarí ní múigíre.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 122,
    content: 'Yaikio íingagia íngí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 123,
    content: 'Yaciara mahatha yongithagia cierí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 124,
    content: 'Ya rwanio ínguaga na rwanio.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 125,
    content: 'Ya riika íthínjaga na mweri.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 126,
    content: 'Ya riika ríngí íríaga íkíhurunjaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 127,
    content: 'Ya mwene ndírí njereri.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 128,
    content: 'Ya matharara ígwatagia ya nyeki.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 129,
    content: 'Ya kúhea íhíaga na mambere.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 130,
    content: 'Wega urí mbere ya kahinga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 131,
    content: 'Wega Umaga na múcií.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 132,
    content: 'Ya gwíthuríra ndírí igorwe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 133,
    content: 'Woni wí njací, wagi wí matarania.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 134,
    content: 'Wonaga ní agaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 135,
    content: 'Wona ciene waruta ndúngúrú,  wona ciaku wacokia ndúngúrú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 136,
    content: 'Wíteithie ngúteithie.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 137,
    content: 'Wíra wa múingí úragaga kírimú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 138,
    content: 'Wí kúngariúra ta mútura wa ihíí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 139,
    content: 'Wíhíke múgogo útanatendera.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 140,
    content: 'Wíigíire ndahútaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 141,
    content: 'Weru wa arume ndwagaga kúnunga',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 142,
    content: 'Weru úgúthogoranírwo ndwagaga rúitíki..',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 143,
    content: 'Wega waríire karigú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 144,
    content: 'Wega na wega iticemanagia.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 145,
    content: 'We urí múnyota matahwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 146,
    content: 'We urí karía nime.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 147,
    content: 'Warúgaga ní atobongaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 148,
    content: 'Waríire athínirie waigire.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 149,
    content: 'Wairire ndakerúha.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 150,
    content: 'Wainaga ní eroragíra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 151,
    content: 'Útatiga ndakora.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 152,
    content: 'Útenderú ndúrí njamba.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 153,
    content: 'Útenderu urí nja ndurí múthemere.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 154,
    content: 'Úthayo na ng"aragu ní múndú na múrú wa nyina.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 155,
    content: 'Úthaka ndúríyagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 156,
    content: 'Úthaka ní mwíthúwa.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 157,
    content: 'Úthuri wa gítonga ndúnungaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 158,
    content: 'Úthuuri wa kanua úkíríte wa míaka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 159,
    content: 'Úthú ndúhingagia.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 160,
    content: 'Úthuuro mwega ndúiyoraga ikúmbí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 161,
    content: 'Útoí kúbíra oí kúhioria.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 162,
    content: 'Útoí úú, oí úú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 163,
    content: 'Útonga ndúhanyongagírwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 164,
    content: 'Útonga wí mathagu.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 165,
    content: 'Útukú ndútumagwo nguo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 166,
    content: 'Wa githi ndagiragia wa kío akagía',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 167,
    content: 'Wa haraya úhoragíra njíra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 168,
    content: 'Wa karimú wítirimagia na múgí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 169,
    content: 'Wa kúona ndakíhítia',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 170,
    content: 'Wa mbúri ndúteagwo útarí mwatie.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 171,
    content: 'Wa maitho ti wa rúthiomi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 172,
    content: 'Wa múingí wathora mútíri.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 173,
    content: 'Wa múru únungaga úrí thiaka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 174,
    content: 'Wa mwega ta wa múru.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 175,
    content: 'Wa mwírí ndúmemyagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 176,
    content: 'Wa mwitúmo ndúremaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 177,
    content: 'Wa ngai úraragio ní magoto.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 178,
    content: 'Wa riika rímwe ndúbíríkaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 179,
    content: 'Wanaruona anarúmenya.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 180,
    content: 'Rúrímí rwa ngía rútithiraga kímanda.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 181,
    content: 'Rúrí Kuma njora rúticokaga túhú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 182,
    content: 'Rúrí itara rúthekaga rúrí riiko.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 183,
    content: 'Rúrakora múndú rútirí múthemere.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 184,
    content: 'Rúmwe rútioranagwo, no kúrekania rúrekanagia.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 185,
    content: 'Rúmíra nguo haría hatarí ihoro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 186,
    content: 'Rúúí rútithamaga múkaro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 187,
    content: 'Rúúí rúnenehagio ní túthima.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 188,
    content: 'Rúhonge rwa mútí rútithendúkaga múndú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 189,
    content: 'Rúhiú rúgútema rútiagaga igeca.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 190,
    content: 'Rúga runaga úta.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 191,
    content: 'Rúúa rúkuhe rútire thogora.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 192,
    content: 'Riúwa rítiowe gítonga no ngía theri',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 193,
    content: 'Riúwa rítietagírera múthamaki.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 194,
    content: 'Ritho ti ndami.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 195,
    content: 'Ritho rímenaga njamba',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 196,
    content: 'Ritho ríríragia iniúrú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 197,
    content: 'Riko na mwana na nda itíoe kwaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 198,
    content: 'Rigí ría nyúmba rítirutagwo rítire nyúmba ya úngí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 199,
    content: 'Rítwa ní mbokio.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 200,
    content: 'Rítwa ti mbokio.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 201,
    content: 'Rígu ndútwaranagírwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 202,
    content: 'O múndú ahuragia mwaki na mwíhíríto.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 203,
    content: 'O múndú athondekaga úrírí wake.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 204,
    content: 'Nyúngú ya múingí ndíagaga múteng"úrí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 205,
    content: 'Nyúngú ya maguta ndínguaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 206,
    content: 'Nyúngú ya gana ndímeraga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 207,
    content: 'Nyúngú írugaga na ndíríe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 208,
    content: 'Nyúmba Nini íciraga útuko.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 209,
    content: 'Ngoro itíúmaníire ta njíra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 210,
    content: 'Ngoro ndírumaga túhú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 211,
    content: 'Ngoro ní mútitú mútumanu na ndúkítonyeka ní múndú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 212,
    content: 'Ngoro ní múrú wa nyina na múndú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 213,
    content: 'Ngoro íríaga kíría íkwenda.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 214,
    content: 'Ng"ombe yahíithiyo njaú ikamagírwo ikaya',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 215,
    content: 'Ng"ombe nguru ndícayaga túhú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 216,
    content: 'Ng"ombe itionagwo ní ithayo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 217,
    content: 'Ngingo ya múría-ng"úrú ní gíthito na rúrígí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 218,
    content: 'Ngingo ndíkíraga kiongo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 219,
    content: 'Ngi ímwe yoragia múgúgúta',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 220,
    content: 'Ngía yethagwo múkuha wayo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 221,
    content: 'Ngía na múigwa itikomaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 222,
    content: 'Ng"enda thí ndíagaga mútegi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 223,
    content: 'Ngemi ciumaga na múcií.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 224,
    content: 'Ngatia ciathie hiti cieragara.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 225,
    content: 'Ngatho ithingatagio ingí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 226,
    content: 'Ngarí ndíoí gúkunya ní kúonio yonirio.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 227,
    content: 'Uuge wa ngai ndúrí múgarúri.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 228,
    content: 'Ngai ní Nene .',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 229,
    content: 'Ngai ndaríyaga ngima.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 230,
    content: 'Ngai ndagiagiyagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 231,
    content: 'Ngai ndaroraga gíthithi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 232,
    content: 'Ngai arímaga na hiú nduhu.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 233,
    content: 'Ngai e tha.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 234,
    content: 'Ngarari ní kamena.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 235,
    content: 'Ngarari ní gíthúria kía mbaara.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 236,
    content: 'Ng"aragu ya múndú úngí ndíngígiria ngome',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 237,
    content: 'Ngaita itíríyagírwo kwenda.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 238,
    content: 'Ní gúkaga gúkíra mwíte.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 239,
    content: 'Ní itumaga na itirue.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 240,
    content: 'Ní hiti múgambíre.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 241,
    content: 'Ndutura írurumaga irorete gítara kíayo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 242,
    content: 'Ndutura karimú ítukagíríria karíki-iní kamwe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 243,
    content: 'Ndurumo igírí itiguanaga ingígamba.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 244,
    content: 'Ndundu ya mwana na nyina.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 245,
    content: 'Nduma ndíhítithagia múthii mbere.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 246,
    content: 'Ndúra iciaraga míigwa.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 247,
    content: 'Ndúkanúmíríre ta njúú na ngigí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 248,
    content: 'Ndúkanime nduma mbíra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 249,
    content: 'Ndúkamínyithie wa itara.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 250,
    content: 'Ndúkagerekanie toro na gíkuú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 251,
    content: 'Ndúirio ní mata ta thua.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 252,
    content: 'Ndúire nyiki ta múrogi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 253,
    content: 'Ndúgú ya mwana ímatagio ní nyina.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 254,
    content: 'Ndúgú nyingí ithatagia múhuko.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 255,
    content: 'Ndúgú ní makinya.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 256,
    content: 'Ndúgú írutagwo njíra-iní.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 257,
    content: 'Ndúgetange ta kíhía kía múcai.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 258,
    content: 'Ndúgíra na kaigwa kayo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 259,
    content: 'Ndonga ímwe ndíhingaga iriúko.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 260,
    content: 'Ndonga Nanu írúgítwo ní múkarí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 261,
    content: 'Ndiuníkaga thondu.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 262,
    content: 'Ndithúire múmíoni ta múmíaníríri.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 263,
    content: 'Ndikwenda wíkwatíríre ta kíeha.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 264,
    content: 'Ndia ngiri íninaga andú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 265,
    content: 'Ndírí njega ndírínganaga na múthí mwega.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 266,
    content: 'Ndírí ndíiyúragíra kúría íkúgaragario.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 267,
    content: 'Ndíkúraga na mígiria.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 268,
    content: 'Ndíambaga na magúa.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 269,
    content: 'Ndíyani ndíkinyaga iraka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 270,
    content: 'Ndíyakagwo ta ya wakiní.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 271,
    content: 'Ndía kahora ndígiaga gukameria.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 272,
    content: 'Ndeto itimataga ta iria.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 273,
    content: 'Ndegwa nyinyi íhaicaga Ng"ombe na mútwe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 274,
    content: 'Nda yumaga múici na múrogi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 275,
    content: 'Ndaregirwo ní ikere ta njagathi ikeregwo ní guoya.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 276,
    content: 'Ndakúrama kínganga nawe wanama kíngware',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 277,
    content: 'Ndakúhaka maguta nawe wahaka múhu',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 278,
    content: 'Mwoni úmúthí tiwe mwoni  rúciú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 279,
    content: 'Mwítwari ndarí haaro',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 280,
    content: 'Mwíthínia ndathenukaga, no múthínio ní athenúkaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 281,
    content: 'Mwíríhíria níwe múru.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 282,
    content: 'Mwírí ti icoya atí ní úgútembúka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 283,
    content: 'Mwírane ndúrí ngarari',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 284,
    content: 'Mwínyamaria ndarí ikwa nyúmú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 285,
    content: 'Mwíikaria ndarí rúruto.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 286,
    content: 'Mwíikaria ndarí haro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 287,
    content: 'Mwííro wa ngoro ndúkinyaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 288,
    content: 'Mwííri eítaga nyoko.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 289,
    content: 'Mwígerekanio wareire kíora matina.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 290,
    content: 'Mwícaríria ndarí karo gatuhu',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 291,
    content: 'Mwetereri aríaga ya múgwato.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 292,
    content: 'Mwere mwega úmenyagwo na ngetho.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 293,
    content: 'Mwene kíratu níwe úúí haría kírarumíra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 294,
    content: 'Mwínjani míkuri ndoí úngí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 295,
    content: 'Mwendwo ndarí ngarari.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 296,
    content: 'Mwendia ní agúraga',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 297,
    content: 'Mwendi úthaka ndacayaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 298,
    content: 'Mwendi úúru ní awonaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 299,
    content: 'Mwendi múhíríga útuíkane etagia rúrímí na mbere ndarúríaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 300,
    content: 'Mwendi irura ní múcini',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 301,
    content: 'Mwendi kagwací gatungu ní kwenjera.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 302,
    content: 'Mwega ní ongagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 303,
    content: 'Mwato ndúitagírwo mwana.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 304,
    content: 'Mwaria ciene arigagwo ní ciake.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 305,
    content: 'Mwarí mwega ahetokagíra thome wa ngía',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 306,
    content: 'Mwaníki wa míatú ambaga kúíaníka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 307,
    content: 'Mwanake wí na indo ndoihanaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 308,
    content: 'Mwanake ní kíenyu kía ngai.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 309,
    content: 'Mwana wí na ithe ndanyuaga muma.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 310,
    content: 'Mwana wína thahu ndatigaga kíríro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 311,
    content: 'Mwana wa rwendo aríaga nyina na ithe',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 312,
    content: 'Mwana wa ngoriai ndekagíra njingiri kúgúrú',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 313,
    content: 'Mwana wa ngarí akunyataga ta nyina.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 314,
    content: 'Mwana wa ndigwa ndarí maithori.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 315,
    content: 'Mwana wa ndigwa níwe úúí kwírera.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 316,
    content: 'Mwana úrí múreri ndatangaga maí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 317,
    content: 'Mwana ndetagia ithe nyama.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 318,
    content: 'Mwana ndahoragwo ithe arí ho.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 319,
    content: 'Mwana ndaheanagwo',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 320,
    content: 'Mwana mwende ndoí kúinia thúmbí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 321,
    content: 'Mwana mwega no nda.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 322,
    content: 'Mwamúkíri ndairaga ngoro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 323,
    content: 'Mwambi nacio tiwe múrigia nacio',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 324,
    content: 'Mwaki wakana múno wítunyaga nyama.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 325,
    content: 'Mwagi maguta oigaga king"aru ní úndú úmwe na maguta.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 326,
    content: 'Mwagi wa maguta oigaga hunyú ní wa arúme.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 327,
    content: 'Mwaga gúkua mwaruta mbaara.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 328,
    content: 'Múremwo ní ndúgo oigaga nja írí mahiga',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 329,
    content: 'Múregi akírwo ndaregaga akíhetwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 330,
    content: 'Múrathi atukagia múrathi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 331,
    content: 'Múragani ndakayaga, no múragwo akayaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 332,
    content: 'Múra na múndú ti múra na hiti.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 333,
    content: 'Múnyaka ndúrokaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 334,
    content: 'Múnyaka úrí mbere ya kahinga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 335,
    content: 'Múnyaka ní únyakokagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 336,
    content: 'Múndwithia rímwe ndagacoka kúndwithia ríngí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 337,
    content: 'Múndú wa ngai ndahotagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 338,
    content: 'Múndú útathiaga augaga no nyina úthiaga wega.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 339,
    content: 'Múndú útathiaga athínjaga mwatí atoí ndúrúme irí gícegú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 340,
    content: 'Múndú útarí mbúri ndendaga nyama',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 341,
    content: 'Múndú urí na úndú otaga  mwaki na riúwa',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 342,
    content: 'Múndú úkanyuíríire úí karí rita.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 343,
    content: 'Múndú múnyotu athiaga rúúí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 344,
    content: 'Múndú múihwa ní múhootani.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 345,
    content: 'Múndú múhúúnu etaga úhútií múkoroku.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 346,
    content: 'Múndú múhoreri ndarí ngúí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 347,
    content: 'Múndú múka ndúragagwo',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 348,
    content: 'Múndú múkarí aimaga úhúúnií.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 349,
    content: 'Múndú múka na igúrú itimenyagírwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 350,
    content: 'Múndú múka ndatúmagwo thirí-iní.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 351,
    content: 'Múndú múgo ndaganagwo itúra ríao.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 352,
    content: 'Múndú múgo wa gwítúma ndarí rúa.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 353,
    content: 'Múndú múgo nderagúragíra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 354,
    content: 'Múndú múgí ndarí múhere wa uhoro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 355,
    content: 'Múndú múúgi akuaga na Matanya.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 356,
    content: 'Múmeni úngí amúrutaga mbakí iniúrú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 357,
    content: 'Múmítuíria na múmíríi ndakímíona ríkí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 358,
    content: 'Múmbi arugaga na ngío.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 359,
    content: 'Múciari ní etíagíra rúciaro rwake.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 360,
    content: 'Múcií ndwathagwo ní útawakire.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 361,
    content: 'Múcií ní wa kúrara ti gútinda',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 362,
    content: 'Múcií úrí mbúri ndwagaga kahuno.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 363,
    content: 'Múcií warí mbúri ndwagaga mbimbi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 364,
    content: 'Mícingú írí yunaga hiti kúgúrú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 365,
    content: 'Múciríri kírimú ndaigaga múthegi thí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 366,
    content: 'Múciri úmwe ndagambaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 367,
    content: 'Múcukani ndarí múcií mwega',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 368,
    content: 'Múgambo muge ndugongagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 369,
    content: 'Múgambo wa kíríndí no ta wa ngai.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 370,
    content: 'Múgarúri igírí ndagaga ígúcura.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 371,
    content: 'Múgathí wanatwíka ndúcokaga kúigana.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 372,
    content: 'Múgathí wa kuona úteaga wa mwene.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 373,
    content: 'Múgeni ameaga mbíríra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 374,
    content: 'Múgeni kírimú ndarugagírwo njohi ',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 375,
    content: 'Múgeni ndahúhitaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 376,
    content: 'Múgeni ní rúúí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 377,
    content: 'Múgethi útukú agethire kírí muura',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 378,
    content: 'Múgí ní mútaare.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 379,
    content: 'Útaraga waimwo ndútaraga waheo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 380,
    content: 'Múgíri rwa kúnyitora agirí rwa kúnyitia',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 381,
    content: 'Múgiti ndagaga rúhara.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 382,
    content: 'Múgogo úmwe ndúhikaga iriúko',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 383,
    content: 'Múgoma múrungu ní útúraga nyúngú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 384,
    content: 'Múgúnda úraga na rútere.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 385,
    content: 'Múgúnda úmenyagwo na magetho',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 386,
    content: 'Múgúnda wene ndúinagwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 387,
    content: 'Múguí útarí wa awa úkúndembúríra thiaka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 388,
    content: 'Múhaka na ciake , itimúragia thakame.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 389,
    content: 'Múhandi tiwe múrei.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 390,
    content: 'Múharwo níwe athikataga gíthaka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 391,
    content: 'Múhehwo na matú merí ndagiuaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 392,
    content: 'Múhenania ndathekaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 393,
    content: 'Múhenia ago oigaga múrimú ní wathira.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 394,
    content: 'Múhenio arí matukú',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 395,
    content: 'Múhenio ti múgí ta múhenania.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 396,
    content: 'Múheo ndagathimaga',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 397,
    content: 'Múhíkana na kúría ahíkanaga na gúitwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 398,
    content: 'Múhiki aríaga rúbia.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 399,
    content: 'Múhiki atumaga rwerú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 400,
    content: 'Múhíríga ti Múhírígo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 401,
    content: 'Múhotwo ndararaga kíharo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 402,
    content: 'Múici athamagia múrogi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 403,
    content: 'Múici na kíhíí athiraga kíeha gíakua.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 404,
    content: 'Múici úri hunyú arindagíra úrí maguta.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 405,
    content: 'Múici útarí múnyite ní múría gake.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 406,
    content: 'Múciari ndairagio ngoro ní kímira kía mwana wake.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 407,
    content: 'Múciari arí tha.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 408,
    content: 'Múceera na múkúndú akúndúkaga take.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 409,
    content: 'Múcemi akúrire múkungi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 410,
    content: 'Múcaria úngí ndamwagaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 411,
    content: 'Múcarí úrutagwo ndúgú-iní.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 412,
    content: 'Múcakwe úgúithagia njamba.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 413,
    content: 'Mondo yene ndeikagio njara mwanake.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 414,
    content: 'Mítheko ítarí gíthimi yumaga kanua-iní ga kírimú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 415,
    content: 'Míhehú yongagírírwo gúkunga',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 416,
    content: 'Mígúgúta írí ndíambanagírio.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 417,
    content: 'Mígambo ní míruke ya ngoro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 418,
    content: 'Menya kwígerera ndúkore.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 419,
    content: 'Ma haraya matininaga nyota.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 420,
    content: 'Mburungo nyinyi írí múthiomeri írúgíte Nene ítarí múthiomeri',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 421,
    content: 'Mbugi ndíkírítemúriha.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 422,
    content: 'Mbu ya arúme ítíkagwo ní athamaki.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 423,
    content: 'Mbúri ya ngía yaringíríra ní guo Bata úringagíríra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 424,
    content: 'Mbúri ngúrú ndítihaga túhú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 425,
    content: 'Mbúri yene múitha ní gútú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 426,
    content: 'Mbúri ya rwagatha ndíkiraga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 427,
    content: 'Mbúri na kaana itirumagwo.',
     name: 'Thaayú, No irathimúrwo.' },
      { id: 428,
    content: 'Mbúri itiugagírwo mbu.',
     name: 'Thaayú, No irathimúrwo.' },
      { id: 429,
    content: 'Mbúri igucagio ní múnyú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 430,
    content: 'Mbura ítakura ígwatagia rúhuho',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 431,
    content: 'Mbogo nyingí itirí nyama.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 432,
    content: 'Mbere no mbere thutha ní múgiano.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 433,
    content: 'Mbere ní gíkeno thutha ní maithori.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 434,
    content: 'Mbere ndíriragwo ta thutha.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 435,
    content: 'Mbía íminaga ndarwa na igutha.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 436,
    content: 'Mbarí ya ngeka yakorirwo ítarí yeka',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 437,
    content: 'Mbaara ya aka ndírí Ng"ondu.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 438,
    content: 'Mbaara ti úcúrú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 439,
    content: 'Mbaara yakwa íríhagwa na íngí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 440,
    content: 'Maúndú ní ndiganíro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 441,
    content: 'Matumbí ma njamba matitúranaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 442,
    content: 'Matukú ti ma kiumia.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 443,
    content: 'Matukú ní Ngúríríri',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 444,
    content: 'Matirúka ní maingí kúrúga magúa',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 445,
    content: 'Matigana nomo moranwo',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 446,
    content: 'Matienda mwako mendaga múrugúrio',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 447,
    content: 'Mathanwa me kíondo kímwe matiagaga gúkomorania.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 448,
    content: 'Matarí maku mahítúkaga úgítua irútú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 449,
    content: 'Marakara ní gatei.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 450,
    content: 'Marakara ma arúme matituraga ta ma aka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 451,
    content: 'Maithori ti rúthiomi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 452,
    content: 'Maitho maronana marí nduíríro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 453,
    content: 'Maitho ma ciúra matigiragia ng"ombe inyue.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 454,
    content: 'Maitho ma arúme ti ma irang"a.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 455,
    content: 'Maitho matiendaga kíndú kíhínju.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 456,
    content: 'Maheni ti thirí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 457,
    content: 'Maheni marí mútino.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 458,
    content: 'Maguta makúrú matinaga rwímbo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 459,
    content: 'Mageria nomo mahota.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 460,
    content: 'Maaí maraitíka matirí múhítíre',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 461,
    content: 'Kúona kímera ti kúría.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 462,
    content: 'Kwíonera ti kwírwo',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 463,
    content: 'Kwígita ti guoya.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 464,
    content: 'Kwígeria múcií ní kwígeria mathína.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 465,
    content: 'Kwaria ti gútua cira.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 466,
    content: 'Kúría thirí ní kúríha.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 467,
    content: 'Kúría thí ti kúría tíri.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 468,
    content: 'Kúría naí gútigiragia múndú akaría wega.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 469,
    content: 'Kúría múno ní kúoria nda',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 470,
    content: 'Kwamwendwo gútirí iríma.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 471,
    content: 'Kúría tene ti gúkoroka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 472,
    content: 'Kwa mwaria gúkíúra kwa mukiri kworire tene.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 473,
    content: 'Kúhoya kwa arúme ní maitho',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 474,
    content: 'Kúhonoka nyogoti kúhonoka ndigana',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 475,
    content: 'Kúhítia ní kwa njamba.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 476,
    content: 'Kúhíka ní Kuna.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 477,
    content: 'Kúgunagwo mwíthiomeri ti múthiomerwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 478,
    content: 'Kúgúrú ní irata thí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 479,
    content: 'Kagúrú karí múhu gatigana ke ime.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 480,
    content: 'Kúgera múgathí ti gútinia',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 481,
    content: 'Kúganwo ní kúúra',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 482,
    content: 'Komu athínirie kaigú wa nyina.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 483,
    content: 'Komu ateire kaigú wa nyina',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 484,
    content: 'Kíuga gítheri gítirutanagírwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 485,
    content: 'Kiríríria thuti ti ruo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 486,
    content: 'Kíúra kíaringio rúúí kiugaga níkío kíeringia.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 487,
    content: 'Kíúnúhu gítiríagírwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 488,
    content: 'Kúmatha gútirí hinya ta kúramata.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 489,
    content: 'Kúira ti kúrita',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 490,
    content: 'Kúhúra maaí na ndírí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 491,
    content: 'Kúhúta na kúhúna ititiganaga',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 492,
    content: 'Kúhoya ti kúiya.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 493,
    content: 'Kúrí gúkahúka gúticokaga ndebe',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 494,
    content: 'Kúrí gúciara úru ta kíhía gígíciara na mútwe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 495,
    content: 'Kúrí arúme na maiyúria ndua',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 496,
    content: 'Kúnyitwo ti kúohwo',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 497,
    content: 'Kúnyiha ti gútinio.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 498,
    content: 'Kúngú maitú na hunyú wake.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 499,
    content: 'Kúmenya werú ní kúútinda.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 500,
    content: 'Kúmenya múno ní kúmenyúka.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 501,
    content: 'Kíúma gítihatagírírio rúga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 502,
    content: 'Kíruka gía kímbu gítirí gíathirwo ní múng"úng"útú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 503,
    content: 'Kíronda kía mwene gítimúiragia ngoro.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 504,
    content: 'Kíringeri kía aka no ruenji rúkírega.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 505,
    content: 'Kírimú níta mwatú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 506,
    content: 'Kírimú kíongaga nyina arí múkuú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 507,
    content: 'Kírimú kíahúna gítiririkanaga rúciú nígíkahúta.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 508,
    content: 'Kírimú gía gwíkígia kírúgíte kía múciaríre.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 509,
    content: 'Kírimú kíhithaga rwembea-iní rwa nyúmba kíúí gítikuonwo',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 510,
    content: 'Kírimú gítindagia andú njíra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 511,
    content: 'Kíríti kírí ngoro gítiunanagírwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 512,
    content: 'Kíríro kírí itúúra gítikereka múndú akome.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 513,
    content: 'Kíríro kía mbúri ní ndari.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 514,
    content: 'Kírí kwíhia ciehetie ciothe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 515,
    content: 'Kírí kúmía imíaga ciothe',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 516,
    content: 'Kírathimo kía ngai gítitíraga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 517,
    content: 'Kíonje gítihoyaga njohi mícií írí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 518,
    content: 'Kíongo kíenjagwo úría mwene úiga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 519,
    content: 'Kínya kírí itina níkío kíigaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 520,
    content: 'Kíndú no mwene múhoi ahoe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 521,
    content: 'Kíndú kíúru no múndú ethúkítie we mwene.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 522,
    content: 'Kíndú kíúru no kíronda',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 523,
    content: 'Kíndú kíene gítirí ndokeirwo núú',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 524,
    content: 'Kínandú kía múcií gítihakagwo múgeni',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 525,
    content: 'Kíhooto ní indo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 526,
    content: 'Kíhooto kíringaga rúúí rúiyúru.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 527,
    content: 'Kíhooto kiunaga úta múgete.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 528,
    content: 'Kíhíí gíkúrú na ithe ní úndú úmwe.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 529,
    content: 'Kígína gítininúkagio irio itarí ngúrú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 530,
    content: 'Kíeru ní kíiraga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 531,
    content: 'Kíero ní úimbo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 532,
    content: 'Kíega ta kí gítithiraga',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 533,
    content: 'Kíara kíihúragio ní gúita mahuti.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 534,
    content: 'Kíambíríria ngwací nyingí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 535,
    content: 'Kíambi nda níkío gíakúra.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 536,
    content: 'Kíama gítirúgaga rúúi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 537,
    content: 'Kíaga ngúi kíabaca.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 538,
    content: 'Karí nda gatiyumbúraga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 539,
    content: 'Kareraria korotagúo na mútí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 540,
    content: 'Kanywanjui kerathaga kero gako',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 541,
    content: 'Kanyoni kebariti keninagíra njoya.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 542,
    content: 'Kanya gatune ní mwamúkaníro',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 543,
    content: 'Kanua weríire.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 544,
    content: 'Kanua kendagia kíongo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 545,
    content: 'Kanua ní ikahú',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 546,
    content: 'Kanua kene gatinyuaga muma.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 547,
    content: 'Kanua karía karíire mbeú gacokaga kúria "kahanda kí ".',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 548,
    content: 'Kanua kí mata gatiagaga wa kuga',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 549,
    content: 'Kaaníra njara íría úkomeire',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 550,
    content: 'Kamúingí koyaga ndírí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 551,
    content: 'Kamúhúthia kaharúrúkagia mwatú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 552,
    content: 'Kamau mwerú ní airaga',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 553,
    content: 'Kamamíríria gateire múgúnda múríme',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 554,
    content: 'Kaihú gacangacangi gatigaga kwao gúgíthínjwo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 555,
    content: 'Kahúnií gatúhaga urírí wa nyina',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 556,
    content: 'Kahúnií gatiúí mwírí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 557,
    content: 'Kahiú getainwo na rwenji',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 558,
    content: 'Kahíí kúgí ta ithe kabaritaga ta mígwí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 559,
    content: 'Kahíí ka mwathi kamenyaga kúgereka',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 600,
    content: 'Kahiga gakúrú gatiagararagwo ní maaí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 601,
    content: 'Kagwací ka mwana wene noko kahoragia mwaki.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 602,
    content: 'Kara kamwe Gatiúragaga ndaa.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 603,
    content: 'Kana karere ní cuwe gatingírúngíka',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 604,
    content: 'Kaana ka ngarí gakunyataga tayo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 605,
    content: 'Múcií úrí inooro ndútuhagia túhiú',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 606,
    content: 'Itonga irugaga na ngío.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 607,
    content: 'Itonga igírí itirí nyoni.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 608,
    content: 'Itherú ríúragaga ndebe',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 609,
    content: 'Itherú riumaga mbaara.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 610,
    content: 'Itherú rítirutagírwo múgúí.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 611,
    content: 'Itherú rítiringaga ini',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 612,
    content: 'Ithe wa thaka ndarí matú',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 613,
    content: 'Ithare ríagúka hacokaga múgumo',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 614,
    content: 'Ithaga ríene rínogagia ngingo.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 615,
    content: 'Itihingagia mbugi',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 616,
    content: 'Ita rítarí ndundu rítitahaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 617,
    content: 'Ita rítarí ndundu ríhúragwo ní kahíí na karúthanju.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 618,
    content: 'Irí Gíkûyú itirí úkabi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 619,
    content: 'Irio hio itiumaga mbúri',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 620,
    content: 'Irí kúhía itiúragírwo',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 621,
    content: 'Irí kanua itirí nda.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 622,
    content: 'Irí gwíthamba itícokaga gwota mwaki.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 623,
    content: 'Iríaga na mbugi kúrí ogwati.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 624,
    content: 'Irí gúthua ndongoria itikinyagíra nyeki',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 625,
    content: 'Indo ní kúrímithanio.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 626,
    content: 'Indo ciene irí mútino.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 627,
    content: 'Ikinya ría múkúrú ríkinyaga múruna.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 628,
    content: 'Karagúthwo níko koí kwígita',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 629,
    content: 'Karega nyina gatihonaga.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 630,
    content: 'Kíratú gíatagwo na kúgúrú kwa mwene.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 631,
    content: 'Karothúa na mbírí',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 632,
    content: 'Karara kenyitia',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 633,
    content: 'Karanga hako gatiúmagia.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 634,
    content: 'Andú matiúí ngú, moí ithendú',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 635,
    content: 'Andú matarí ndundu mahoragwo na njúgúma ímwe.',
     name: 'Thaayú, No irathimúrwo.' }
     ,
     { id: 636,
    content: 'Amba úrute kíhuti kíría kírí riitho ríaku.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 637,
    content: 'Aka na mahiu itirí ndúgú.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 638,
    content: 'Andú anja matirí cia ndiiro no cia nyiníko.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 639,
    content: 'Aka erí ní nyúngú igírí cia úrogi.',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 640,
    content: 'Aikaragia mbia ta njúú ngigí',
     name: 'Thaayú, No irathimúrwo.' }
     ,
     { id: 641,
    content: 'Agíkúyú moí kúhitha ndía , matiúí kúhitha úhoro',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 642,
    content: 'Ageni erí na karirúi kao',
     name: 'Thaayú, No irathimúrwo.' },
     { id: 643,
    content: 'Ageni erí matirí útugíre.',
     name: 'Thaayú, No irathimúrwo.' },
  {
    id: 644,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî wîriraga agîthiî ta ağîcoka"
  },
  {
    id: 645,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî wîtaga ithe wa üngi baba"
  },
  {
    id: 646,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirika gûteaga njamba noru"
  },
  {
    id: 647,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirika nî gûte"
  },
  {
    id: 648,
    name: "Thaayú, No irathimúrwo.",
    content: "Gûtungata gûtingîgiri mañdû agatungatwo"
  },
  {
    id: 649,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūkira kūrī ngatho"
  },
  {
    id: 650,
    name: "Thaayú, No irathimúrwo.",
    content: "Guoko kwa Ngai gûtieraga"
  },
  {
    id: 651,
    name: "Thaayú, No irathimúrwo.",
    content: "Güciara üru ti kwenda kwa mwene"
  },
  {
    id: 652,
    name: "Thaayú, No irathimúrwo.",
    content: "Güciara ti kūmīa"
  },
  {
    id: 653,
    name: "Thaayú, No irathimúrwo.",
    content: "Gücukagwo ūtaguteo"
  },
  {
    id: 654,
    name: "Thaayú, No irathimúrwo.",
    content: "Guoya ûtûrâgia ûkia mücîrî"
  },
  {
    id: 655,
    name: "Thaayú, No irathimúrwo.",
    content: "Guoko kwa Ngai gûtieraga"
  },
  {
    id: 656,
    name: "Thaayú, No irathimúrwo.",
    content: "Gwakîa kwarama, gwatuka gwakundera"
  },
  {
    id: 657,
    name: "Thaayú, No irathimúrwo.",
    content: "Gwethera gîtahî mûka"
  },
  {
    id: 658,
    name: "Thaayú, No irathimúrwo.",
    content: "Gwîka wega kûmathaga üngî"
  },
  {
    id: 659,
    name: "Thaayú, No irathimúrwo.",
    content: "Harî mûthurî hatitangagwo maaî"
  },
  {
    id: 660,
    name: "Thaayú, No irathimúrwo.",
    content: "Haro nî ya mûka ûrî ihîî"
  },
  {
    id: 661,
    name: "Thaayú, No irathimúrwo.",
    content: "Haro nî ya mûka ûrî thiirî"
  },
  {
    id: 662,
    name: "Thaayú, No irathimúrwo.",
    content: "Hîta îtanakîra"
  },
  {
    id: 663,
    name: "Thaayú, No irathimúrwo.",
    content: "Hinga ndîkinyaga iraka"
  },
  {
    id: 664,
    name: "Thaayú, No irathimúrwo.",
    content: "Hinya ndûigana ûrûme"
  },
  {
    id: 665,
    name: "Thaayú, No irathimúrwo.",
    content: "Hinya ndûrî indo"
  },
  {
    id: 666,
    name: "Thaayú, No irathimúrwo.",
    content: "Hiti ciathiî mbwe ciegangara"
  },
  {
    id: 667,
    name: "Thaayú, No irathimúrwo.",
    content: "Hiti îtaga îrîa îngî wamûtîrî"
  },
  {
    id: 668,
    name: "Thaayú, No irathimúrwo.",
    content: "Hiti yugaga arûme nî ogî, monaga gîcînga ngwatîro"
  },
  {
    id: 669,
    name: "Thaayú, No irathimúrwo.",
    content: "Hiti ndîrîaga mwana, na mûî ûrîa irî ngoroku."
  },
  {
    id: 670,
    name: "Thaayú, No irathimúrwo.",
    content: "Hûngû îreraga harîa mbûri îrathînjîrwo"
  },
  {
    id: 671,
    name: "Thaayú, No irathimúrwo.",
    content: "Hûngû îgîthîî îgûrû ndîatigire thî kûrî kwega."
  },
  {
    id: 672,
    name: "Thaayú, No irathimúrwo.",
    content: "Hûni nene îgîraga hûhita"
  },
  {
    id: 673,
    name: "Thaayú, No irathimúrwo.",
    content: "Hururu îthekaga rwaro"
  },
  {
    id: 674,
    name: "Thaayú, No irathimúrwo.",
    content: "Îciaraga ûru mwene oine"
  },
  {
    id: 675,
    name: "Thaayú, No irathimúrwo.",
    content: "İganagwo yaarî iria yakua"
  },
  {
    id: 676,
    name: "Thaayú, No irathimúrwo.",
    content: "İgîtunywo mwana îikagîrio mûngû"
  },
  {
    id: 677,
    name: "Thaayú, No irathimúrwo.",
    content: "İgîkaya nî nûme"
  },
  {
    id: 678,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūkira nī rūmena"
  },
  {
    id: 679,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūkirīrīria kwagīra kīeha"
  },
  {
    id: 680,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūkua mūrīo ta kīgūa"
  },
  {
    id: 681,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūkūra nī kūūru: ngathiī urīrī ngīcayaga"
  },
  {
    id: 682,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūkuhīha ti gūtiniō"
  },
  {
    id: 683,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūkuhīrīria mbaara tikuo kūrūa"
  },
  {
    id: 684,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūkungagwo ūtukū ti mūthenya"
  },
  {
    id: 685,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūte inya ūkinyīrīte inyanya"
  },
  {
    id: 686,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūteithagio wīteithītie"
  },
  {
    id: 687,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūtema na kanua ti gūtema na rūhiū"
  },
  {
    id: 688,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthama nīkuo kūhika kwa arūme"
  },
  {
    id: 689,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthekererwo nī andū ti kūrīrīrwo nī hiti"
  },
  {
    id: 690,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthekererwo ti kurīrīrwo"
  },
  {
    id: 691,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthekio ti kwendwo"
  },
  {
    id: 692,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthīgia mbura ūtongīte matūgūta"
  },
  {
    id: 693,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthiī gūtigiragia mūndū acoke"
  },
  {
    id: 694,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthiī nī kuona"
  },
  {
    id: 695,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthimba ti kuura"
  },
  {
    id: 696,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthinga kūrūgīte gūtonga"
  },
  {
    id: 697,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthūra ng'ombe nī gūthūra kamūkwa kayo"
  },
  {
    id: 698,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthukagīrio wanatega itega"
  },
  {
    id: 699,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūthūragwo mūndū ūrīendwo"
  },
  {
    id: 700,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūtirī gītatūirie kīngī"
  },
  {
    id: 701,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūtirī gīthīnji ūtathīnja"
  },
  {
    id: 702,
    name: "Thaayú, No irathimúrwo.",
    content: "Gūtirī gūkūra na kūrara kerī"
  },
  {
    id: 703,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütiri müciî ürî kahîi ütakarugwo mûtwe"
  },
  {
    id: 704,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî müici na mücûthîrîria"
  },
  {
    id: 705,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî müki ûrehage ûrugarî"
  },
  {
    id: 706,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî mündû ûi harîa egûthiî no harîa aumîtî"
  },
  {
    id: 707,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî mündû wendaga gûtûngana na nyoni njûru"
  },
  {
    id: 708,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî mündû ûtangîtuîka wa ndigwa"
  },
  {
    id: 709,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî mündû wonaga wega wake, no kuonwo wonagwo."
  },
  {
    id: 710,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî mûrîo ûtainagia rûthîa"
  },
  {
    id: 711,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî mûthenya ûkîaga ta ûngî"
  },
  {
    id: 712,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî mûtumia wenjagîrwò mbûî kwa nyina."
  },
  {
    id: 713,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî mwana ûngîtema agîtemera ithe"
  },
  {
    id: 714,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ndûnyû îtarî mûgûrûki"
  },
  {
    id: 715,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ngware îtarî mûhurîrie wayo"
  },
  {
    id: 716,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ngware nyinyi mahuria-inî"
  },
  {
    id: 717,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî njamba îrurumaga imera igîrî"
  },
  {
    id: 718,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî nyama na ngirinyû"
  },
  {
    id: 719,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî nyoni njega mwere-inî"
  },
  {
    id: 720,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ûciaragwo arî mûgî"
  },
  {
    id: 721,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ûcokaga harîa arûmîirwò kaara"
  },
  {
    id: 722,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ûikagia itimû atarî na harîa akûratha."
  },
  {
    id: 723,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ûkinyaga mûkinyîre wa ûngî"
  },
  {
    id: 724,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ûndû ûtarî kîhumo"
  },
  {
    id: 725,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ûrîragio nî ûkîa wene"
  },
  {
    id: 726,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ûrirû ûtonwò"
  },
  {
    id: 727,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ûru ûtûûraga, no wega ûtûûraga"
  },
  {
    id: 728,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ûta ûtarî nyama"
  },
  {
    id: 729,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî rîtwa rîtakûria mwana (Rîtwa nî mbûkio)"
  },
  {
    id: 730,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî thingira ûciraga ta ûngî"
  },
  {
    id: 731,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî thome Ngai atooî"
  },
  {
    id: 732,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî ûthûire tiga akîaga"
  },
  {
    id: 733,
    name: "Thaayú, No irathimúrwo.",
    content: "Gütirî wa nda na wa mûgongo"
  },

  {
    id: 734,
    name: "Thaayú, No irathimúrwo.",
    content: "Andü matiüî ngamini"
  },
  {
    id: 735,
    name: "Thaayú, No irathimúrwo.",
    content: "Andü me ndügü matirî itherü"
  },
  {
    id: 736,
    name: "Thaayú, No irathimúrwo.",
    content: "Arüme maigananagio nî mîbuto"
  },
  {
    id: 737,
    name: "Thaayú, No irathimúrwo.",
    content: "Arüme me rwamba"
  },
  {
    id: 738,
    name: "Thaayú, No irathimúrwo.",
    content: "Bata ndübatabataga"
  },
  {
    id: 739,
    name: "Thaayú, No irathimúrwo.",
    content: "Cia athuri inyuagîra thutha"
  },
  {
    id: 740,
    name: "Thaayú, No irathimúrwo.",
    content: "Cia kionje itigayagwo kîmuoyo"
  },
  {
    id: 741,
    name: "Thaayú, No irathimúrwo.",
    content: "Cia müciî ti como"
  },
  {
    id: 742,
    name: "Thaayú, No irathimúrwo.",
    content: "Ciakorire wacü mûgünda (Ciumaga igürü irî ndinangie)"
  },
  {
    id: 743,
    name: "Thaayú, No irathimúrwo.",
    content: "Ciatura ngüyü irîaga ng'umo"
  },
  {
    id: 744,
    name: "Thaayú, No irathimúrwo.",
    content: "Cia üthoni ciambagwo nguhî"
  },
  {
    id: 745,
    name: "Thaayú, No irathimúrwo.",
    content: "Ciaigana nî Ciaigana"
  },
  {
    id: 746,
    name: "Thaayú, No irathimúrwo.",
    content: "Ciîgwatağîrîra mareru"
  },
  {
    id: 747,
    name: "Thaayú, No irathimúrwo.",
    content: "Ciethanaga ikîgua, no ikîümbüka itîkoragwo hamwe"
  },
  {
    id: 748,
    name: "Thaayú, No irathimúrwo.",
    content: "Ciira münene nî ükîa"
  },
  {
    id: 749,
    name: "Thaayú, No irathimúrwo.",
    content: "Ciira münene nî wa üthoni ûgîkua"
  },
  {
    id: 750,
    name: "Thaayú, No irathimúrwo.",
    content: "Ciira wa kirimü ütindaga kîharo"
  },
  {
    id: 751,
    name: "Thaayú, No irathimúrwo.",
    content: "Ciira wa müici ndumagîrio kîharo"
  },
  {
    id: 752,
    name: "Thaayú, No irathimúrwo.",
    content: "Ciira wothe wambagirîrio na nda"
  },
  {
    id: 753,
    name: "Thaayú, No irathimúrwo.",
    content: "Ciira wa kîrimü üciragwo nî Ngai kîrî toro."
  },
  {
    id: 754,
    name: "Thaayú, No irathimúrwo.",
    content: "Cunagwo rükomo, kîmenyi akamenya ikiunwo."
  },
  {
    id: 755,
    name: "Thaayú, No irathimúrwo.",
    content: "Ehera thakîrio"
  },
  {
    id: 756,
    name: "Thaayú, No irathimúrwo.",
    content: "Gakîyoha nï köi nikarîina"
  },
  {
    id: 757,
    name: "Thaayú, No irathimúrwo.",
    content: "Garürîra mbeu ti ya kinya kîmwe"
  },
  {
    id: 758,
    name: "Thaayú, No irathimúrwo.",
    content: "Gatamî ke mondo yene gatingîkuratïra nguo"
  },
  {
    id: 759,
    name: "Thaayú, No irathimúrwo.",
    content: "Gathutha konagia mündü njîra"
  },
       {
    id: 760,
    name: "Thaayú, No irathimúrwo.",
    content: "Gatitū ka mūimwo nī irī noko karī mītī"
  },
  {
    id: 761,
    name: "Thaayú, No irathimúrwo.",
    content: "Gatitū ka ngoro gatiunagwo"
  },
  {
    id: 762,
    name: "Thaayú, No irathimúrwo.",
    content: "Gatinyinyiraga gatarī gakunye"
  },
  {
    id: 763,
    name: "Thaayú, No irathimúrwo.",
    content: "Gatuma kainagia mūrigwo"
  },
  {
    id: 764,
    name: "Thaayú, No irathimúrwo.",
    content: "Gatundu koragithirie Watatua"
  },
  {
    id: 765,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīathī gītharagio nī gaka kamwe"
  },
  {
    id: 766,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīathī kīrī mūrugīrwo"
  },
  {
    id: 767,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīathī kīrīagwo nī kīngī"
  },
  {
    id: 768,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīathī kīūmū no kīa mūrokero"
  },
  {
    id: 769,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīaka gītīkagio kīarara"
  },
  {
    id: 770,
    name: "Thaayú, No irathimúrwo.",
    content: "Gweterera ti kūinaina"
  },
  {
    id: 771,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīcegū kīa andū aingī ti kīega"
  },
  {
    id: 772,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīcigo kīa mūgūnda gītinyihaga"
  },
  {
    id: 773,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīikaro kimwe kīrī ndaa"
  },
  {
    id: 774,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīkūrū kīega no kīratina"
  },
  {
    id: 775,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīkuū gītīraragīrio"
  },
  {
    id: 776,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīthaka gītīgunaga muni, kīgunaga mukī"
  },
  {
    id: 777,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīthaka kīa mūici nī gūkaana"
  },
  {
    id: 778,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīthīnjīro gītiagaga thakame"
  },
  {
    id: 779,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīthūmba gītirī mūrimū wa ngoro"
  },
  {
    id: 780,
    name: "Thaayú, No irathimúrwo.",
    content: "Gīthūri kīrī mwatū wa ngotoko"
  },
  {
    id: 781,
    name: "Thaayú, No irathimúrwo.",
    content: "Gītiiro kīa mūka wene gītīkagio athii"
  },
  {
    id: 782,
    name: "Thaayú, No irathimúrwo.",
    content: "Gītoī kīmerayaga kierwo"
  },
  {
    id: 783,
    name: "Thaayú, No irathimúrwo.",
    content: "Gītoī kīraragia kīuī njīra"
  },
  {
    id: 784,
    name: "Thaayú, No irathimúrwo.",
    content: "Gītonga kīrīaga mūnyuko"
  },
  {
    id: 785,
    name: "Thaayú, No irathimúrwo.",
    content: "Güceera nī kūhīga"
  },
  {
    id: 786,
    name: "Thaayú, No irathimúrwo.",
    content: "Gücekeka ti gūicūhio"
  },
  {
    id: 787,
    name: "Thaayú, No irathimúrwo.",
    content: "Güciara kunaga irigū ngingo"
  }

];

export default data;